let windowW       = $(window).width();
let windowH       = $(window).innerHeight();
let hSize;

let _isSP;
let prewidth = window.innerWidth;

//preload
import {preload} from "../include/module";
preload();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

//showMovie
import {showMovie} from "../include/module";
showMovie();

//showImg
import {showImg} from "../include/module";
showImg();

//divideCharacter
import {divideCharacter} from "../include/module";
divideCharacter();

//anchorLink
// import {anchorLink} from "../include/module";
// anchorLink();

// $(window).on('resize load' , function() {
//   if(windowW <= 1024){
//     _isSP = true;
//   } else {
//     _isSP = false;
//   };

//   //リサイズ処理 ブレイクポイントを跨いだらリロード
//   var nowWidth = window.innerWidth;
//   if(prewidth !== nowWidth){
//     if(prewidth < 1025) {
//       if(nowWidth >= 1025){
//         location.reload();
//       }
//     }else {
//       if(nowWidth < 1025){
//         location.reload();
//       }
//     }
//   };
// });

$(window).on('load' , function() {

  $(".st-Container").addClass('is-show');
  scrollDetailAnime();
  toggleImg();

});


// ------------------------------------------------------------------------
// toggleImg
// ----- BOTH
// ------------------------------------------------------------------------
let changeBtn  = document.getElementById('change-Btn');
let _isChange  = false;

const toggleImg = () => {

  if(changeBtn != null) {
    changeBtn.addEventListener('click', () => {

      if(!_isChange){
        setTimeout(function(){
          $(".panel-item-on").removeClass('is-show');
          $(".panel-item-off").addClass('is-show');
          $("#change-Btn").removeClass('on');
          _isChange = true;
        },0);
      } else {
        setTimeout(function(){
          $(".panel-item-on").addClass('is-show');
          $(".panel-item-off").removeClass('is-show');
          $("#change-Btn").addClass('on');
          _isChange = false;
        },0);
      }

      }, false);
  }

};


// ------------------------------------------------------------------------
// scrollDetailAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollDetailAnime = () => {

  function getDuration() {
    return $('.index-Keyvisual_Container').height();
  }

  const controller = new ScrollMagic.Controller();

  //ttl
  const scene = new ScrollMagic.Scene({
    triggerElement:'.index-Keyvisual_Container',
    // duration: 500,
    triggerHook: 1,
    duration: getDuration,
    offset: '0'
  })
  .setClassToggle(".index-Keyvisual_Container", "sticky")
  // .addIndicators({name: "1"})
  .addTo(controller);

  //　スクロールで発火
  const targets = document.querySelectorAll(".js-scrollAnimation");
  const targetsArray = Array.prototype.slice.call(targets); //Array
  targetsArray.forEach(target => {
    //シーンを作成
  new ScrollMagic.Scene({
        triggerElement: target,
        triggerHook: .9
    })
    .setClassToggle(target, "is-animated")
    .addTo(controller);
  });

};



// WEBPACK FOOTER //
// ./src/assets/js/detail/script.js